import Dashboard from "layouts/dashboard";
import Profile from "./layouts/profile";
import AdminSignIn from "./layouts/authentication/admin-sign-in/AdminSignIn";
import ForgotPassword from "layouts/authentication/passwords/ForgotPassword";
import PasswordReset from "layouts/authentication/passwords/PasswordReset";
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import CategoryIcon from "@mui/icons-material/Category";
import EmailIcon from "@mui/icons-material/Email";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CustomerSupport from "examples/Icons/CustomerSupport";
import TicketList from "layouts/Ticket/TicketList";
import AdminTicketList from "layouts/AdminTickets/AdminTickesList";
import AddTicket from "layouts/Ticket/AddTicket";
import EditTicket from "layouts/Ticket/EditTicket";
import AddCustomers from "layouts/customers/AddCustomers";
import EditCustomers from "layouts/customers/EditCustomers";
import CustomerList from "layouts/customers/CustomerList";
import AddEmployee from "layouts/employees/AddEmployee";
import EditEmployee from "layouts/employees/EditEmployee";
import EmployeesList from "layouts/employees/EmployeesList";
import AddSubscription from "layouts/Subscriptions/AddSubscription";
import SubscriptionList from "layouts/Subscriptions/SubscriptionList";
import UpcomingFreeService from "layouts/UpcomingFreeService/UpcomingFreeService";
import CustomerSubscriptionList from "layouts/Subscriptions/CustomerSubscriptionList";
import CustomerViewSubscription from "layouts/Subscriptions/CustomerViewSubscription";
import EditSubscription from "layouts/Subscriptions/EditSubscription";
import AdminEditTicket from "layouts/AdminTickets/AdminEditTicket";
import AdminAddTicket from "layouts/AdminTickets/AdminAddTicket";
import EmployeeTicketList from "layouts/EmployeeTickets/EmployeeTicketsList";
import CustomerAssetsList from "layouts/CustomerAssets/CustomerAssetsList";
import ViewTickets from "layouts/AdminTickets/ViewTickets";
import Locations from "./layouts/Locations/index";
import ViewAddresses from "layouts/customers/ViewAddresses";
import ViewDivisions from "layouts/customers/ViewDivisions";
import ViewCustomerDivisions from "layouts/profile/ViewCustomerDivisions";
import ViewCustomerMembers from "layouts/profile/ViewCustomerMembers";
import TemplatesList from "layouts/EmailTemplates/TemplatesList";
import AdminProfile from "layouts/AdminProfile";
import Home from "layouts/Home";
import About from "layouts/Home/About";
import Contact from "layouts/Home/Contact";
import PrivacyPolicy from "layouts/Home/PrivacyPolicy";
import TermsConditions from "layouts/Home/TermsConditions";
import AddPage from "layouts/Pages/AddPage";
import PagesList from "layouts/Pages/PagesList";
import ViewTicket from "layouts/Ticket/ViewTicket";
import EmployeeViewTicket from "layouts/EmployeeTickets/EmployeeViewTicket";
import GeneralPreferences from "layouts/GeneralPreferences";
import CustomerViewAsset from "layouts/CustomerAssets/CustomerViewAsset";
import EditPage from "layouts/Pages/EditPage";
import AssetsList from "layouts/Assets/AssetsList";
import TypesPage from "layouts/Types";
import EventsCalender from "layouts/EmployeeTickets/EventsCalender";
import EventsOverview from "layouts/EmployeeTickets/EventsOverview";
import EmployeeClosedTickets from "layouts/AdminTickets/EmployeeClosedTickets";
import SparePartList from "layouts/stockManagers/spareParts/SparePartList";
import { BoxesIcon, ListOrdered } from "lucide-react";
import OrderList from "layouts/stockManagers/orders/OrderList";
import ViewOrder from "layouts/stockManagers/orders/ViewOrder";
import SparePartRequest from "layouts/stockManagers/spareParts/SparePartRequest";
import {
  NotificationImportantOutlined,
  RequestQuoteOutlined,
  Settings as SettingsIcon,
  Person as PersonIcon,
  Tune as TuneIcon,
  Description as DescriptionIcon,
  Autorenew as AutorenewIcon,
  CardGiftcard as CardGiftcardIcon,
} from "@mui/icons-material";
import AdminViewAsset from "layouts/CustomerAssets/AdminViewAsset";
import RenewalList from "layouts/Renewal/RenewalList";
import ExpiringSubscriptions from "layouts/ExpiringSubscriptions/ExpiringSubscriptions";
import BranchHeadSubscriptions from "layouts/BranchHead/BranchHeadSubscriptions";
import BranchHeadAssets from "layouts/BranchHead/BranchHeadAssets";
import BranchHeadTickets from "layouts/BranchHead/BranchHeadTickets";
import BranchHeadAddTicket from "layouts/BranchHead/BranchHeadAddTicket";
import ViewTicketMultimedia from "layouts/AdminTickets/ViewTicketMultimedia";
import ViewCustomer from "layouts/customers/ViewCustomer";
import VendorSubscriptionPage from "layouts/BillingSubscription/VendorSubscriptionPage";
const publicRoutes = [
  {
    type: "collapse",
    name: "Home Page",
    route: "/home",
    component: <Home />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "About Page",
    route: "/about",
    component: <About />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Contact Page",
    route: "/contact",
    component: <Contact />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Privacy Policy Page",
    route: "/privacy-policy",
    component: <PrivacyPolicy />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Terms Conditions Page",
    route: "/terms-conditions",
    component: <TermsConditions />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Admin Sign In",
    route: "admin/sign-in",
    component: <AdminSignIn />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Forget Password",
    route: "/forgot-password",
    component: <ForgotPassword />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Reset Password",
    route: "/reset-password/:token",
    component: <PasswordReset />,
    noCollapse: true,
  },
];
const privateRoutes = [
  //Admin,supervisor,employee,stockManager,BranchHead routes
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/admin/profile",
    icon: <CustomerSupport size="12px" />,
    component: <AdminProfile />,
    roles: ["admin", "supervisor", "employee", "stockManager", "BranchHead"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    roles: [
      "admin",
      "supervisor",
      "employee",
      "stockManager",
      "superAdmin",
      "BranchHead",
    ],
    noCollapse: true,
    adminMainNav: true,
  },
  {
    type: "collapse",
    name: "Subscribe",
    key: "subscribe",
    route: "/subscribe",
    icon: <SubscriptionsIcon sx={{ fontSize: 12 }} />,
    component: <VendorSubscriptionPage />,
    roles: ["admin"],
    noCollapse: true,
  },
  //Admin and supervisor routes
  {
    type: "collapse",
    name: "Type Settings",
    key: "typesPage",
    route: "/types",
    icon: <CategoryIcon sx={{ fontSize: 12 }} />,
    component: <TypesPage />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Tickets",
    key: "adminTicketslist",
    route: "/admin/tickets-list",
    icon: <ConfirmationNumberIcon sx={{ fontSize: 12 }} />,
    component: <AdminTicketList />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
    adminMainNav: true,
  },
  {
    type: "collapse",
    name: "Members",
    key: "employeeslist",
    route: "/employees-list",
    icon: <SupervisorAccountIcon sx={{ fontSize: 12 }} />,
    component: <EmployeesList />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Customers",
    key: "customerslist",
    route: "/customers-list",
    icon: <SupervisorAccountIcon sx={{ fontSize: 12 }} />,
    component: <CustomerList />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
    adminMainNav: true,
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <SettingsIcon sx={{ fontSize: 12 }} />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: false,
    collapse: [
      { type: "title", title: "Types", key: "settings-types-title" },
      { type: "collapse", name: "Type settings", route: "/types", key: "typesPage", icon: <CategoryIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "title", title: "Profile & pages", key: "settings-profile-title" },
      { type: "collapse", name: "Profile", route: "/admin/profile", key: "profile", icon: <PersonIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "collapse", name: "General preference", route: "/general-preference", key: "general", icon: <TuneIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "collapse", name: "Pages", route: "/pages-list", key: "pages", icon: <DescriptionIcon sx={{ fontSize: 12 }} />, roles: ["admin", "superAdmin"] },
      { type: "title", title: "Subscriptions & billing", key: "settings-subs-title" },
      { type: "collapse", name: "Subscriptions", route: "/subscriptions-list", key: "subscriptionlist", icon: <SubscriptionsIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "collapse", name: "Expiring", route: "/expiring-subscriptions-list", key: "expiringsubscriptionlist", icon: <NotificationImportantOutlined sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "collapse", name: "Renewal", route: "/renewal-list", key: "renewallist", icon: <AutorenewIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "title", title: "Locations & templates", key: "settings-loc-title" },
      { type: "collapse", name: "Locations", route: "/locations", key: "Locationslist", icon: <FmdGoodIcon sx={{ fontSize: 12 }} />, roles: ["admin", "superAdmin"] },
      { type: "collapse", name: "Templates", route: "/templates-list", key: "templateslist", icon: <EmailIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "title", title: "Tickets & service", key: "settings-tickets-title" },
      { type: "collapse", name: "Closed tickets", route: "/admin/employee-closed-tickets", key: "closedticketslist", icon: <ConfirmationNumberIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "collapse", name: "Free service", route: "/upcoming-free-service", key: "upcomingfreeservice", icon: <CardGiftcardIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "title", title: "More", key: "settings-more-title" },
      { type: "collapse", name: "Members", route: "/employees-list", key: "employeeslist", icon: <SupervisorAccountIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
      { type: "collapse", name: "Assets", route: "/assets-list", key: "assetList", icon: <CategoryIcon sx={{ fontSize: 12 }} />, roles: ["admin", "supervisor", "superAdmin"] },
    ],
  },
  {
    type: "collapse",
    name: "Assets",
    key: "assetList",
    route: "/assets-list",
    icon: <CategoryIcon sx={{ fontSize: 12 }} />,
    component: <AssetsList />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Subscription",
    key: "subscriptionlist",
    route: "/subscriptions-list",
    icon: <SubscriptionsIcon sx={{ fontSize: 12 }} />,
    component: <SubscriptionList />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "General Preference",
    key: "general",
    route: "/general-preference",
    icon: <CustomerSupport size="12px" />,
    component: <GeneralPreferences />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Expiring Subscriptions",
    key: "expiringsubscriptionlist",
    route: "/expiring-subscriptions-list",
    icon: <SubscriptionsIcon sx={{ fontSize: 12 }} />,
    component: <ExpiringSubscriptions />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Renewal",
    key: "renewallist",
    route: "/renewal-list",
    icon: <SubscriptionsIcon sx={{ fontSize: 12 }} />,
    component: <RenewalList />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Free Service",
    key: "upcomingfreeservice",
    route: "/upcoming-free-service",
    icon: <NotificationImportantOutlined sx={{ fontSize: 12 }} />,
    component: <UpcomingFreeService />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Closed Tickets",
    key: "closedticketslist",
    route: "/admin/employee-closed-tickets",
    icon: <ConfirmationNumberIcon sx={{ fontSize: 12 }} />,
    component: <EmployeeClosedTickets />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/admin/employee-closed-tickets",
    component: <EmployeeClosedTickets />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pages",
    key: "pages",
    route: "/pages-list",
    icon: <CustomerSupport size="12px" />,
    component: <PagesList />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/add-ticket",
    component: <AddTicket />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/add-customer",
    component: <AddCustomers />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/edit-customer/:id",
    component: <EditCustomers />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/add-employee",
    component: <AddEmployee />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/edit-employee/:id",
    component: <EditEmployee />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/add-subscription",
    component: <AddSubscription />,
    roles: ["admin", "superAdmin", "supervisor"],
    noCollapse: true,
  },
  {
    route: "/edit-subscription/:id",
    component: <EditSubscription />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/customer/edit-ticket/:id",
    component: <EditTicket />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/admin/add-ticket",
    component: <AdminAddTicket />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/admin/edit-ticket/:id",
    component: <AdminEditTicket />,
    roles: ["admin", "supervisor", "employee", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/admin/ticket-view/:id",
    component: <ViewTickets />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/address-view/:id",
    component: <ViewAddresses />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/divisions-view/:id",
    component: <ViewDivisions />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/assets/view/:id",
    component: <AdminViewAsset />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/customer/view/:id",
    component: <ViewCustomer />,
    roles: ["admin", "superAdmin", "supervisor"],
    noCollapse: true,
  },
  {
    route: "/admin/ticket-images/:id",
    component: <ViewTicketMultimedia />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  //Only Admin Routes
  {
    type: "collapse",
    name: "Templates",
    key: "templateslist",
    route: "/templates-list",
    icon: <EmailIcon sx={{ fontSize: 12 }} />,
    component: <TemplatesList />,
    roles: ["admin", "supervisor", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Locations",
    key: "Locationslist",
    route: "/locations",
    icon: <FmdGoodIcon sx={{ fontSize: 12 }} />,
    component: <Locations />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/add-page",
    component: <AddPage />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  {
    route: "/edit-page/:id",
    component: <EditPage />,
    roles: ["admin", "superAdmin"],
    noCollapse: true,
  },
  //Employee Routes
  {
    type: "collapse",
    name: "Tickets",
    key: "employeeTicketslist",
    route: "/employee-tickets-list",
    icon: <Office size="12px" />,
    component: <EmployeeTicketList />,
    roles: ["employee"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Calender",
    key: "employeecalender",
    route: "/employee/calender",
    icon: <Office size="12px" />,
    component: <EventsCalender />,
    roles: ["employee"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Events Overview",
    key: "eventsoverview",
    route: "/employee/eventsoverview",
    icon: <Office size="12px" />,
    component: <EventsOverview />,
    roles: ["employee"],
    noCollapse: true,
  },
  {
    route: "/employee/ticket-view/:id",
    component: <EmployeeViewTicket />,
    roles: ["employee", "superAdmin"],
    noCollapse: true,
  },
  //BranchHead Routes
  {
    type: "collapse",
    name: "Tickets",
    key: "branchHead-ticketslist",
    route: "/branch-head/tickets-list",
    icon: <ConfirmationNumberIcon sx={{ fontSize: 12 }} />,
    component: <BranchHeadTickets />,
    roles: ["BranchHead"],
    noCollapse: true,
  },
  {
    route: "/branch-head/add-ticket",
    component: <BranchHeadAddTicket />,
    roles: ["BranchHead"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Assets",
    key: "branchHead-assetList",
    route: "/branch-head/assets-list",
    icon: <CategoryIcon sx={{ fontSize: 12 }} />,
    component: <BranchHeadAssets />,
    roles: ["BranchHead"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Subscription",
    key: "branchHead-subscriptionlist",
    route: "/branch-head/subscriptions-list",
    icon: <SubscriptionsIcon sx={{ fontSize: 12 }} />,
    component: <BranchHeadSubscriptions />,
    roles: ["BranchHead"],
    noCollapse: true,
  },
  //Customer Routes
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/customer/profile",
    icon: <CustomerSupport size="12px" />,
    component: <Profile />,
    roles: ["customer"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Tickets",
    key: "ticketslist",
    route: "/customer/tickets-list",
    icon: <ConfirmationNumberIcon sx={{ fontSize: 12 }} />,
    component: <TicketList />,
    roles: ["customer"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Subscription",
    key: "customerSubscriptionlist",
    route: "/customer-subscriptions-list",
    icon: <SubscriptionsIcon sx={{ fontSize: 12 }} />,
    component: <CustomerSubscriptionList />,
    roles: ["customer"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Assets",
    key: "customerassetslist",
    route: "/customer/assets-list",
    icon: <Office size="12px" />,
    component: <CustomerAssetsList />,
    roles: ["customer"],
    noCollapse: true,
  },
  {
    route: "/customer/ticket-view/:id",
    component: <ViewTicket />,
    roles: ["customer", "superAdmin", "BranchHead"],
    noCollapse: true,
  },
  {
    route: "/customer/assets-view/:id",
    component: <CustomerViewAsset />,
    roles: ["customer", "superAdmin", "BranchHead"],
    noCollapse: true,
  },
  {
    route: "/view-subscription/:id",
    component: <CustomerViewSubscription />,
    roles: ["customer", "BranchHead"],
    noCollapse: true,
  },
  {
    route: "/customer-members-view/:id",
    component: <ViewCustomerDivisions />,
    roles: ["admin", "supervisor", "superAdmin", "customer"],
    noCollapse: true,
  },
  {
    route: "/customer-divisions-view/:id",
    component: <ViewCustomerMembers />,
    roles: ["admin", "supervisor", "superAdmin", "customer"],
    noCollapse: true,
  },
  //Stock Manager Routes
  {
    type: "collapse",
    name: "Items Request",
    key: "spare-parts-request",
    route: "/spare-parts-request",
    icon: <RequestQuoteOutlined sx={{ fontSize: 12 }} />,
    component: <SparePartRequest />,
    roles: ["stockManager", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Spare Parts",
    key: "spareparts",
    route: "/spare-parts-list",
    icon: <BoxesIcon size="12px" />,
    component: <SparePartList />,
    roles: ["stockManager", "superAdmin"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orderslist",
    route: "/orders-list",
    icon: <ListOrdered size="12px" />,
    component: <OrderList />,
    roles: ["stockManager"],
    noCollapse: true,
  },
  {
    route: "/view-order/:id",
    component: <ViewOrder />,
    roles: ["stockManager"],
    noCollapse: true,
  },
];
export { publicRoutes, privateRoutes };
